import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SearchFilterComponent } from '../../shared/search-filter/search-filter.component';
import { PaginationComponent } from '../../shared/pagination/pagination.component';
import { StateService } from 'src/app/services/state.service';
import { StateModalComponent } from './state-modal/state-modal.component';


@Component({
  selector: 'app-state',
  imports: [CommonModule, SearchFilterComponent, PaginationComponent],
  templateUrl: './state.component.html',
  styleUrls: ['./state.component.css']
})
export class StateComponent implements OnInit {
  
  constructor(
      private dialog: MatDialog,
      private StateService: StateService,
      private changeDetectorRef: ChangeDetectorRef
  ) {} 

  
  StateList: any[] = [];
  filteredData: any[] = [];
  pagedData: any[] = [];
  pageSize: number = 10;

  ngOnInit(): void {
      this.getState();
  }

  getState(){
    this.StateService.getStates().subscribe({
      next: (res: any) => {
        this.StateList = res;
        this.filteredData = res;
        this.changeDetectorRef.detectChanges();
      }});
  };

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
  }

  openModal(item: any, mode: any, title: any) {

    const dialogRef = this.dialog.open(StateModalComponent, {
      data: { item, mode, title },
      width: '800px',
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
       
        if (!res) return
        if (res) {
          this.getState();
        }
      }
    });
  }

}
